@if (error){
<div class="a-notification a-notification--text -error" role="alert">
  <bosch-ui-icon [name]="alertErrorIcon"></bosch-ui-icon>
  <div class="a-notification__content">
    {{ error }}
  </div>
</div>
}
